import store from '@/store'
const url = process.env.VUE_APP_UPLOAD_URL

export default {
    getAvatarUrl(userIdStr) {
        const accountNumber = store.state.companyAccount.accountNumber //need to initialize this here to get recent state when switching to linked account
        return `${url}${accountNumber}/avatars/${userIdStr}/thumb.jpg`
    },
    getSweldoNowAvatarUrl(userIdStr) {
        return `${url}${process.env.VUE_APP_SWELDONOW_ACCT_NO}/avatars/${userIdStr}/thumb.jpg`
    },
    getProfileAvatarUrl(userIdStr) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/avatars/${userIdStr}/profile.jpg`
    },
    getAttendanceThumbPicUrl(userIdStr, transDate, action) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/attendance/${userIdStr}/${transDate}/${action}/thumb.jpg`
    },
    getAttendancActualPicUrl(userIdStr, transDate, action) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/attendance/${userIdStr}/${transDate}/${action}/actual.jpg`
    },
    getCompanyLogoUrl() {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/company-logo/${store.state.companyLogo}`
    },

    //use getCompanyDocumentUrl
    getCompanyLogoUrlByAccount(accountNumber, fileName) {
        return `${url}${accountNumber}/company-logo/${fileName}`
    },
    //use getCompanyDocumentUrl
    getFaceAIPhoto(fileName) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/face-ai/${fileName}`
    },
    
    getEmployeeDocumentUrl(userId, fileName, type) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/${type}/${userId}/${fileName}`
    },
    getCompanyDocumentUrl(fileName, type) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/${type}/${fileName}`
    },
    getBillingDocumentUrl(billingAccountNumber, fileName, type) {
        return `${url}${billingAccountNumber}/${type}/${fileName}`
    },

    //TODO - use getEmployeeDocumentUrl when converted to auto-preview
    getReimbursementAttachment(userId, fileName) {
        const accountNumber = store.state.companyAccount.accountNumber
        return `${url}${accountNumber}/reimbursements/${userId}/${fileName}`
    },
}